import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useIntl } from 'react-intl';

import 'pages/reports/components/EarlyAccessChip/EarlyAccessChip.scss';

type EarlyAccessChipProps = {
    id?: string;
    className?: string;
};

export const EarlyAccessChip = (props: EarlyAccessChipProps) => {

    const { id, className } = props;

    const { formatMessage } = useIntl();

    const label = formatMessage({ id: 'early_access.86082dfe', defaultMessage: 'Early Access' });

    // Consumed both as tooltip content and inside an aria-label template, so it must be a string.
    const tooltip = formatMessage({
        id: 'this_report_is_available_in_early_access.d2ad8b70', defaultMessage: 'This report is available in Early Access while we continue to validate and refine the experience. Report behavior, presentation, or available data may change as improvements are made.'
    });

    return (
        <OverlayTrigger
            overlay={(
                <Tooltip className="early-access-chip__tooltip" id={id ?? 'early-access-chip-tooltip'}>
                    {tooltip}
                </Tooltip>
            )}
            placement="top"
            trigger={['hover', 'focus']}
        >
            <span
                aria-label={`${label}. ${tooltip}`}
                className={`early-access-chip${className ? ` ${className}` : ''}`}
                role="note"
                tabIndex={0}
            >
                {label}
                <i aria-hidden="true" className="fa-regular fa-circle-info early-access-chip__icon"></i>
            </span>
        </OverlayTrigger>
    );

};
